import React from 'react';
import PropTypes from 'prop-types';
// import { css } from '@bd/bdui-styles/emotion';
import { orderBy, get } from 'lodash';
import withData from '@bd/bdcore-data';

import PlanCard from './PlanCard';

const PlansResults = ({ plans, sort, limit, areaName, showMore }) => {
  return (
    <div className="list-background-color">
      <div className="container">
        <div className="row HomeCardsList Vertical">
          {
            orderBy(plans, sort.field, get(sort, 'dir', 'asc')).slice(0, limit).map(plan => (
              <PlanCard areaName={areaName} plan={plan} key={plan._id} />
            ))
          }
        </div>
        {
          limit < plans.length &&
          <div style={{ textAlign: 'center' }}>
            <button className="btn" onClick={showMore}>Load More</button>
          </div>
        }
      </div>
    </div>
  );
};

PlansResults.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.object),
  areaName: PropTypes.string,
  sort: PropTypes.object,
  limit: PropTypes.number,
  showMore: PropTypes.func.isRequired,
};

PlansResults.defaultProps = {
  plans: [],
  areaName: '',
  sort: null,
  limit: null,
};


export default withData(
  {
    plans: true,
  },
  {
    required: {
      plans: true,
    },
  },
)(PlansResults);



// WEBPACK FOOTER //
// ./src/pages/Plans/PlansResults.js